<template>
  <v-container class="no-margins" fluid>
    <v-data-table
      class="table_card_view mt-0"
      :headers="($vuetify.breakpoint.xsOnly ? headersMobile : headers)"
      :items="orders"
      :mobile-breakpoint="800"
      :footer-props="{
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        'items-per-page-options': [25, 50]
      }"
      :item-class="getColor"
      :group-by="departments ? 'departmentName' : null"
      item-key="id + departmentName"
    >
      <template slot="group.header" slot-scope="props">
        <td colspan="100%">{{ props.group }}</td>
      </template>
      <template slot="item.avser" slot-scope="props">
        <div>{{ props.item.type === 'ExtensionOrder' ? $t('application.company.extension-apprentice') : $t('application.company.distance-apprentice') }}</div>
      </template>
      <template slot="item.person" slot-scope="props">
        <div>{{ get(props, 'item.firstName', '') }} {{ get(props, 'item.lastName', '') }}</div>
      </template>
      <template slot="item.distanceOrderRows" slot-scope="props">
        <div>
          {{ getSummary(props.item.distanceOrderRows) || 
          get(props, 'item.extensionOrder.educationExtension.price', 0) | currency | withCurrencyCode }}
        </div>
      </template>
      <template slot="item.createdAt" slot-scope="props">
        <div>{{ props.item.createdAt | date }}</div>
      </template>
      <template slot="item.state.name" slot-scope="props">
        <div class="status-container">
          <div class="status-container__icon">
            <v-icon>{{ orderStatusIcon(props.item.state.id) }}</v-icon>
          </div>
          <div class="status-container__label">{{ props.item.stateName }}</div>
        </div>
      </template>
      <template slot="item.action" slot-scope="props">
        <div>
          <v-btn
            style="justify-content: center !important"
            class="btn-label action"
            @click="
              $nextTick(() => {
                $router.push({
                  name: get(props, 'item.type', '') === 'ExtensionOrder' ? 'CompanyExtensionOrder' : 'CompanyDistanceOrder',
                  params: {companyId: props.item.companyId, distance_order_id: props.item.id}
                })
              })
            "
            aria-label="Visa"
            color="primary"
            block
          >
            {{ $t('labels.show') }}
          </v-btn>
        </div>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import ActionButton from '@/components/Common/ActionButton'
import {Icons} from '@/components/mixins'
import get from 'lodash/get'
const SugarDate = require('sugar/date')

// @group Company
// CompanyDistanceOrdersList component
export default {
  name: 'CompanyDistanceOrdersList',
  mixins: [Icons],
  props: {
    // orders array
    orders: {
      // `Array`
      type: Array,
      required: true
    },
    departments: Boolean
  },
  data: function () {
    return {
      headers: [
        {text: this.$i18n.t('order.info.number2'), value: 'id', class: 'card_number'},
        {text: this.$i18n.t('order.info.referes'), value: 'avser'},
        {text: this.$i18n.t('order.info.person'), value: 'person'},
        {text: this.$i18n.t('order.info.amount-exl-vat'), value: 'distanceOrderRows'},
        {text: this.$i18n.t('labels.date'), value: 'createdAt'},
        {text: this.$i18n.t('labels.status'), value: 'state.name'},
        {text: '', value: 'action', sortable: false}
      ],
    headersMobile: [
        {text: this.$i18n.t('order.info.number'), value: 'id', class: 'card_number'},
        {text: this.$i18n.t('order.info.referes'), value: 'avser'},
        {text: this.$i18n.t('order.info.person'), value: 'person'},
        {text: this.$i18n.t('order.info.amount-exl-vat'), value: 'distanceOrderRows'},
        {text: this.$i18n.t('labels.date'), value: 'createdAt', width: 120},
        {text: this.$i18n.t('labels.status'), value: 'state.name'},
        {text: '', value: 'action', sortable: false, width: 140}
      ]
    }
  },
  methods: {
    get,
    
    getColor(item) {
      if(item.stateId === 1 && item.latestApprovalDate && item.profession && item.profession.daysUntilOrderApproval && Number(item.profession.daysUntilOrderApproval)>0)
      {
        let daysFromNow= SugarDate.Date(item.latestApprovalDate).daysFromNow();
        let halfTime = item.profession.daysUntilOrderApproval/2

        if (daysFromNow < halfTime) return "bg-yellow";
      }
      return;
    },

    getSummary(rows = []) {
      const price = rows.reduce((acc, row) => {
        return acc + Number(row.price)
      }, 0)
      return price
    }
  }
}
</script>

<style lang="scss">
</style>
